import React from "react";
import Alert from "elevate-ui/Alert";

type Props = {
  alerts: {},
};

const GlobalAlert = ({ alerts = {} }: Props) => {
  const alertsKeys = Object.keys(alerts) || [];
  if (!(alertsKeys && alertsKeys.length)) {
    return null;
  }

  return alertsKeys.map((alert) => (
    <Alert key={alert} color={alert}>
      <div
        dangerouslySetInnerHTML={{
          __html: alerts[alert].join(" | "),
        }}
      />
    </Alert>
  ));
};

export default GlobalAlert;
